import { faroCoreApiClient } from "@api/faro-core-api-client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { convertProjectTypesToSdbProject } from "@store/projects/projects-slice-utils";
import { projectStateToApiArchivingState } from "@utils/project-utils";

/**
 * Fetches projects for the projects map queried by the passed params.
 * It also convert the backend response to SdbProject entities.
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const fetchMapProjects = createAsyncThunk("projects/fetchMapProjects", async ({
  companyId,
  projectArchivingState,
  groupId,
  search,
  sortBy,
  /* eslint-disable @typescript-eslint/naming-convention -- name given by Core API backend */
  requireGpsPosition
}) => {
  const archivingStates = projectArchivingState ? projectStateToApiArchivingState(projectArchivingState) : undefined;
  const response = await faroCoreApiClient.projects.streamProjects({
    companyId,
    archivingStates,
    groupId,
    search,
    sortBy,
    requireGpsPosition
    /* eslint-enable @typescript-eslint/naming-convention */
  });
  return response.map(convertProjectTypesToSdbProject);
});